import React, { useEffect, useState } from "react";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';


export default function SessionTableAccordion({chatHost}) {
  const [sessions, setSessions] = useState([]);

  function _get(endpoint) {
      const credentialsInclude = { credentials: "include" };
      return fetch(chatHost+endpoint, credentialsInclude).then(response => response.json());
  }

  useEffect(() => {
    _get('/get-chat-sessions').then((response) => {
        let formattedData = response.sessions.map((session, index) => {
          return {
            id: index,
            date: session.start_time,
            title: session.title || '',
            lessons: (session.lessons || 'Computing lessons, please reload the page...').split('\n')
          };
        });
        setSessions(formattedData);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  }, []);

  return (
    <Container component="main" maxWidth="s">
      <div>
          <Typography variant="h2">Your Sessions</Typography>
          {sessions.map((session, idx) => {
            return <Accordion key={'Accordion'+idx}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={"panel-" +idx+"-content"}
                id={"panel-"+idx+"-header"}
                key={'AccordionSummary'+idx}>
                <Typography>
                  <small>{new Date(session.date).toLocaleDateString()}&nbsp;</small><b>{session.title}</b>
                </Typography>                
              </AccordionSummary>
              <AccordionDetails id={"panel-"+idx+"-content"} key={'AccordionDetails'+idx}>
                <Typography variant="h5">Key Lessons:</Typography>
                  
                {session.lessons.map((oneLesson, j) => <Typography key={j}>{oneLesson}</Typography>)}
              </AccordionDetails>
            </Accordion>;
          })}
      </div>
      <Button variant="contained" onClick={() => { window.location = '/chat'; }}>New Session</Button>
      <div style={{marginTop: '50px', fontSize: '80%'}}>
        Questions/Comments? Email <a href="mailto:hello@wisdom.bot">hello@wisdom.bot</a>
      </div>
    </Container>
  );
}
